// extracted by mini-css-extract-plugin
export default {"score":"ProfitScore_score__HDzin","arrow":"ProfitScore_arrow__sMmaJ","high":"ProfitScore_high__NpYEa","low":"ProfitScore_low__LLi2z"};